/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import type * as APITypes from '../API';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getVehicleLocation = /* GraphQL */ `query GetVehicleLocation($vehicleId: ID!, $createdAt: String!) {
  getVehicleLocation(vehicleId: $vehicleId, createdAt: $createdAt) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetVehicleLocationQueryVariables, APITypes.GetVehicleLocationQuery>;
export const listVehicleLocations = /* GraphQL */ `query ListVehicleLocations(
  $vehicleId: ID
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelVehicleLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listVehicleLocations(
    vehicleId: $vehicleId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      vehicleId
      latitude
      longitude
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListVehicleLocationsQueryVariables, APITypes.ListVehicleLocationsQuery>;
export const getReservationStatus = /* GraphQL */ `query GetReservationStatus($reservationId: ID!) {
  getReservationStatus(reservationId: $reservationId) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetReservationStatusQueryVariables, APITypes.GetReservationStatusQuery>;
export const listReservationStatuses = /* GraphQL */ `query ListReservationStatuses(
  $reservationId: ID
  $filter: ModelReservationStatusFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReservationStatuses(
    reservationId: $reservationId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      reservationId
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListReservationStatusesQueryVariables, APITypes.ListReservationStatusesQuery>;
export const getDriverIndividualNotification =
  /* GraphQL */ `query GetDriverIndividualNotification($driverId: ID!, $createdAt: String!) {
  getDriverIndividualNotification(driverId: $driverId, createdAt: $createdAt) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDriverIndividualNotificationQueryVariables,
    APITypes.GetDriverIndividualNotificationQuery
  >;
export const listDriverIndividualNotifications = /* GraphQL */ `query ListDriverIndividualNotifications(
  $driverId: ID
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDriverIndividualNotificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDriverIndividualNotifications(
    driverId: $driverId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      driverId
      createdAt
      subject
      body
      eventId
      isRead
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDriverIndividualNotificationsQueryVariables,
  APITypes.ListDriverIndividualNotificationsQuery
>;
export const getVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `query GetVehicleOperationScheduleUpdateManagement(
  $vehicleId: ID!
  $operationDate: String!
) {
  getVehicleOperationScheduleUpdateManagement(
    vehicleId: $vehicleId
    operationDate: $operationDate
  ) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetVehicleOperationScheduleUpdateManagementQueryVariables,
    APITypes.GetVehicleOperationScheduleUpdateManagementQuery
  >;
export const listVehicleOperationScheduleUpdateManagements =
  /* GraphQL */ `query ListVehicleOperationScheduleUpdateManagements(
  $vehicleId: ID
  $operationDate: ModelStringKeyConditionInput
  $filter: ModelVehicleOperationScheduleUpdateManagementFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listVehicleOperationScheduleUpdateManagements(
    vehicleId: $vehicleId
    operationDate: $operationDate
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      vehicleId
      firstVehicleOperationScheduleId
      operationDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListVehicleOperationScheduleUpdateManagementsQueryVariables,
    APITypes.ListVehicleOperationScheduleUpdateManagementsQuery
  >;
export const getMobiPFUserTransactionInformation =
  /* GraphQL */ `query GetMobiPFUserTransactionInformation($orderId: ID!) {
  getMobiPFUserTransactionInformation(orderId: $orderId) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetMobiPFUserTransactionInformationQueryVariables,
    APITypes.GetMobiPFUserTransactionInformationQuery
  >;
export const listMobiPFUserTransactionInformations = /* GraphQL */ `query ListMobiPFUserTransactionInformations(
  $orderId: ID
  $filter: ModelMobiPFUserTransactionInformationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMobiPFUserTransactionInformations(
    orderId: $orderId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      orderId
      userId
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMobiPFUserTransactionInformationsQueryVariables,
  APITypes.ListMobiPFUserTransactionInformationsQuery
>;
